<header class="header">
  <div class="header-left">
    <a href="#" title="Inicio" (click)="home.emit()" routerLink="home">
      <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo">
    </a>


  </div>
  <div class="header-right">
 
    <!--   <span class="org-name"><i class="fas fa-user-circle me"></i>({{Usuario.court}}) {{Usuario.nameCourt}}</span>
    <span class="me dash"> / </span>
    <span class="org-name">{{Usuario.TypeCourt}}</span> -->
    <div class="row">
      <div class="row justify-content-end">
        <span class="col-12 col-sm-auto org-name"><i class="fas fa-landmark"></i></span>
        <span class="col-12 col-sm-auto org-name">{{Usuario.TypeCourt}}</span>
      </div>
      @if(Usuario.courtAux!==Usuario.court){
       <div class="row justify-content-end">
        @if(bBajoSupervision){
        <span class="col-12 col-sm-auto org-name"><i class="fas fa-user-secret"></i></span>
        }
        @else{
          <span class="col-12 col-sm-auto org-name"><i class="fas fa-user-tie"></i></span>
        }
        <span class="col-12 col-sm-auto org-name">({{Usuario.courtAux}}) {{Usuario.nameCourtAux}}</span>
      </div>
    }
      <div class="row justify-content-end">
        <span class="col-12 col-sm-auto org-name"><i class="fas fa-user-circle me"></i></span>
        <span class="col-12 col-sm-auto org-name">({{Usuario.court}}) {{Usuario.nameCourt}}</span>
      </div>
    </div>
    @if(organosAutorizados > 1 || bOrganoSupervisor){
    <a class="btn txt-oscuro" href="javascript:void(0);"  (click)="ChangeCourt()"><span title="Cambio de autoridad"
        class="fas fa-tasks"></span></a>
    }
    <a class="btn txt-oscuro" href="javascript:void(0);"  (click)="logout()"><span title="Cerrar sesión"
        class="fas fa-sign-out-alt"></span></a>
  </div>
</header>